import React, { FC, ReactElement } from 'react';

interface EditionProps {
    children: React.ReactNode;
}

// Only contain the component
const Edition: FC<EditionProps> = (props): ReactElement => {
    const { children } = props;

    return <>{children}</>;
};

export default Edition;
